import image1 from '@/assets/images/news/detail/20200918/1.jpg';
import image2 from '@/assets/images/news/detail/20200918/2.jpg';
import image3 from '@/assets/images/news/detail/20200918/3.jpg';
import image4 from '@/assets/images/news/detail/20200918/4.jpg';
import image5 from '@/assets/images/news/detail/20200918/5.jpg';
import image6 from '@/assets/images/news/detail/20200918/6.jpg';
import image7 from '@/assets/images/news/detail/20200918/7.jpg';

export default {
  id: '20200918', //  模块 id
  title: '坚持比速度重要 | 叮咚绿@2020张江快乐跑', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '9月18日，初秋清晨的张江，气温微凉，草木清新，报名参加2020张江快乐跑的叮咚小伙伴们，早早的集结在活动会场，大家争相与叮咚RUN旗帜合影，活力四射，蓄势待发。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '开跑之前，大家很认真的在做跑前热身运动。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '随着发令枪响，2020张江快乐跑正式开跑，人群中一抹叮咚绿显得特别耀眼。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text:
        '后半程，跑步队伍逐渐拉开了差距。坚持比速度重要！虽然本次跑步活动没有获得最佳名次，但是每一位小伙伴都努力坚持跑到了终点，给他们点赞！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '今年叮咚报名张江快乐跑人数创历史新高，获得了主办方颁发的参加人数最多的队伍 (The Battalion Award)奖励。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text: '健康运动，快乐生活！叮咚RUN一直在路上，叮咚买菜奔跑永不停止！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
  ],
};
